import { Calendar } from "lucide-react";

export const EventsTab = ({ events }) => (
  <div className="space-y-4">
    {events.length === 0 ? (
      <div className="bg-white rounded-xl border border-gray-100 p-12 text-center text-gray-400">
        <Calendar className="w-10 h-10 mx-auto mb-3 opacity-50" />
        <p className="text-sm">No upcoming events at this time.</p>
      </div>
    ) : (
      events.map(evt => (
        <div key={evt.id} className="bg-white rounded-xl border border-gray-100 p-5 hover:shadow-sm transition-shadow">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="font-semibold text-gray-900">{evt.title}</h3>
              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-sm text-gray-500">
                <span>{evt.start_date}{evt.end_date && evt.end_date !== evt.start_date ? ` - ${evt.end_date}` : ""}</span>
                {evt.start_time && <span>{evt.start_time}{evt.end_time ? ` - ${evt.end_time}` : ""}</span>}
                {evt.location && <span>{evt.location}</span>}
              </div>
              {evt.description && <p className="text-sm text-gray-600 mt-2">{evt.description}</p>}
            </div>
            <span className="text-xs px-2.5 py-1 rounded-full bg-warm-50 text-warm-700 font-medium capitalize flex-shrink-0">
              {evt.event_type}
            </span>
          </div>
        </div>
      ))
    )}
  </div>
);
